import React from 'react';

import { Spinner } from 'components';

import styles from '../States.module.scss';

const LoadingScreen = () => (
  <div className={styles.loadingWrap}>
    <Spinner show size="lg" />
  </div>
);

export default LoadingScreen;
